import { CommonModule, DATE_PIPE_DEFAULT_OPTIONS } from '@angular/common';
import { Injectable, NgModule } from '@angular/core';
import { MdbDatepickerModule, MdbDatepickerOptions } from 'src/lib/mdb5-adapted/public-api';

@Injectable({
  providedIn: 'root'
})
export class LMSDateAdapter {

  format(date: Date, displayFormat: object): string {

    if (typeof displayFormat === 'string' && (displayFormat === 'input' || displayFormat =='YYYY-MM-DD')) {
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = date.getFullYear();

      return `${year}-${month}-${day}`;
    }

    return date.toDateString();
  }
}

export const LMS_MATDATE_FORMATS: MdbDatepickerOptions = {
  monthsShort: ['MM'],
  prevMultiYearLabel: 'MMMM YYYY',
  nextMonthLabel: 'MMM YYYY',
  nextYearLabel: 'YYYY',
  prevYearLabel: 'YYYY',
  weekdaysShort: ['DD'],
  weekdaysFull: ['DDDD'],
  weekdaysNarrow: ['DDD']
};

export const LMS_DATE_FORMATS =
{
  parse: {
    dateInput: { month: 'short', year: 'numeric', day: 'numeric' },
  },
  dateFormat: 'yyyy-MM-dd',
  display: {
    dateInput: 'input',
    monthLabel: 'short',
    monthYearLabel: { year: 'numeric', month: 'short' },
    dateA11yLabel: { year: 'numeric', month: 'short', day: 'numeric' },
    monthYearA11yLabel: { year: 'numeric', month: 'short' },
  }
};

@NgModule({
  declarations: [],
  imports: [CommonModule],
  exports: [MdbDatepickerModule],
  providers: [
      {provide: DATE_PIPE_DEFAULT_OPTIONS, useValue: LMS_DATE_FORMATS}
    ]
})

export class LMSDatePickerModule {

}

// @Injectable()
// export class NgbDateDayjsAdapter extends NgbDateAdapter<dayjs.Dayjs> {
//  fromModel(date: dayjs.Dayjs | null): NgbDateStruct | null {
//    if (date && dayjs.isDayjs(date) && date.isValid()) {
//      return { year: date.year(), month: date.month() + 1, day: date.date() };
//    }
//    return null;
//  }

//  toModel(date: NgbDateStruct | null): dayjs.Dayjs | null {
//    return date ? dayjs(`${date.year}-${date.month}-${date.day}`) : null;
//  }
// }
